import {forwardRef} from 'react'
import type {IconProps} from '../types'

export const CheckCircleIcon = forwardRef<SVGSVGElement, IconProps>(
  ({size = 20, color = 'currentColor', className, ...props}, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        id="Subtract"
        d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM17.2129 9.08691C16.7638 8.63804 16.036 8.63797 15.5869 9.08691L11.2002 13.4736L9.41309 11.6865C8.96406 11.2378 8.23614 11.2378 7.78711 11.6865C7.33801 12.1356 7.33801 12.8644 7.78711 13.3135L10.3867 15.9131C10.8358 16.3621 11.5646 16.3622 12.0137 15.9131L17.2129 10.7129C17.6619 10.2638 17.6619 9.53599 17.2129 9.08691Z"
        fill={color}
      />
    </svg>
  ),
)

CheckCircleIcon.displayName = 'CheckCircleIcon'
